import React, { useEffect, useState } from 'react'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { CForm, CRow } from '@coreui/react'
import { Dialog } from 'primereact/dialog';
import { Button } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useCourse } from '../contexts/CourseContext';
import CInput from './CInput';

function AddCourse({ id, courseDetail, editCourseId, visible, setVisible, setEditCourseId, editMode, setEditMode, setCourseDetail, fetchCourses, canCreate, canUpdate, canDelete }) {
    const { getSingleCourse, createCourse, updateCourse, deleteCourse } = useCourse()
    const { restaurantId } = useAuth();

    const [validated, setValidated] = useState(false);

    const handleClose = () => {
        setVisible(false);
        setEditMode(false);
        setEditCourseId(null);
        setCourseDetail({
            name: '',
            restaurant_id: restaurantId
        })
    };

    const fetchSingleCourse = async () => {
        try {
            const course = await getSingleCourse(id);
            if(course){
                setCourseDetail(course);
            }
        } catch (error) {
            console.error('Error fetching single course', error);
        }
    };

    useEffect(() => {
        if (editMode && editCourseId) {
            fetchSingleCourse();
        }
    }, [editMode, editCourseId]);


    const handleDelete = async () => {
        try {
            const confirmed = await confirmDelete();

            if (confirmed) {
                await deleteCourse(id);
                handleClose();
                fetchCourses()
            }
        } catch (error) {
            console.error('Error during delete operation', error);
        }
    };

    const confirmDelete = async () => {
        return new Promise((resolve) => {
            confirmDialog({
                message: 'Are you sure you want to delete this course?',
                header: 'Delete Confirmation',
                icon: 'pi pi-info-circle',
                position: 'top',
                accept: () => resolve(true),
                reject: () => resolve(false),
            });
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if ((editMode && !canUpdate) || (!editMode && !canCreate)) return;

        const form = e.currentTarget;
        setValidated(true);

        if (form.checkValidity() === false) {
            e.stopPropagation();

            const firstInvalidInput = form.querySelector(':invalid');
            if (firstInvalidInput) {
                firstInvalidInput.focus();
                firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {
            try {
                if (visible && restaurantId) {
                    const data = await createCourse({ ...courseDetail, restaurant_id: restaurantId })
                    if (!data.error) {
                        fetchCourses(data.course)
                        handleClose()
                    }
                } else if (editMode && editCourseId && restaurantId) {
                    const data = await updateCourse(id, { ...courseDetail, restaurant_id: restaurantId })
                    if (!data.error) {
                        handleClose()
                        fetchCourses()
                    }
                }
            } catch (error) {
                console.log(error)
            }
        }
    }

    return (
        <div>
            <ConfirmDialog />
            <Dialog draggable={false} header={`${visible ? 'Create Course' : 'Edit Course'}`} visible={visible || (editMode && editCourseId !== null)} style={{ width: '35vw' }} onHide={handleClose}>
                <CForm onSubmit={handleSubmit} noValidate validated={validated}>
                    <div className='fields-container'>
                        <CRow className='mb-4 mt-4'>
                            <CInput
                                label={'Name'}
                                type={'text'}
                                className={'d-flex'}
                                labelClassName={'w-50'}
                                value={courseDetail.name}
                                onChange={(value) => setCourseDetail({ ...courseDetail, name: value })}
                                required={true}
                                errorMessage='Name is required.'
                            />
                        </CRow>
                    </div>
                    <div className={`d-flex button-container ${(editMode && editCourseId && canDelete) ? 'justify-content-between' : 'justify-content-end'}`}>
                        {
                            (editMode && editCourseId && canDelete) && (
                                <div>
                                    <Button color='error' variant="contained" onClick={handleDelete} className='me-2'>
                                        Delete
                                    </Button>
                                </div>
                            )
                        }
                        <div className='d-flex'>
                            <Button onClick={handleClose} fullWidth variant="contained" color="inherit" >
                                Cancel
                            </Button>
                            {((!editMode && canCreate) || (editMode && canUpdate)) && (
                                <Button fullWidth variant="contained" color="primary" type="submit" className="ms-3">
                                    Submit
                                </Button>
                            )}
                        </div>
                    </div>
                </CForm>
            </Dialog>
        </div>
    )
}

export default AddCourse